import { Observable } from 'tsbase/Patterns/Observable/Observable';
import { Messages } from '../core/enums/messages';

export const Message = new Observable<Messages>();
